import React from "react";

/** Which of the chat's two readings the canvas shows. */
export type AnswerScope = "message" | "chat";

export interface ContextGraphScopeToggleProps {
	scope: AnswerScope;
	/**
	 * Whether "This answer" can be chosen at all. A `?chat=` URL with no
	 * message id has no single answer to narrow back to.
	 */
	hasMessage: boolean;
	onScopeChange: (scope: AnswerScope) => void;
}

const BASE =
	"px-3 py-1.5 text-sm transition-colors focus:outline-none focus-visible:ring-2 " +
	"focus-visible:ring-[#008782] disabled:cursor-not-allowed disabled:opacity-50";
const ON = "bg-primary-50 text-primary";
const OFF = "text-text-base hover:bg-gray-50";

/**
 * One answer, or the conversation it belongs to.
 *
 * An answer's graph shows what THAT reply cited. The reply that tests a
 * covenant is built on the reply that walked the EBITDA behind it, and only
 * the conversation view can draw the two as one chain. Two readings, one
 * control, so the reader can step out and back without losing their place.
 */
const ContextGraphScopeToggle: React.FC<ContextGraphScopeToggleProps> = ({
	scope,
	hasMessage,
	onScopeChange,
}) => (
	<div
		role="group"
		aria-label="Graph scope"
		className="flex shrink-0 overflow-hidden rounded-lg border border-gray-300"
	>
		<button
			type="button"
			aria-pressed={scope === "message"}
			disabled={!hasMessage}
			onClick={() => onScopeChange("message")}
			className={`${BASE} ${scope === "message" ? ON : OFF}`}
		>
			This answer
		</button>
		<button
			type="button"
			aria-pressed={scope === "chat"}
			onClick={() => onScopeChange("chat")}
			className={`${BASE} border-l border-gray-300 ${scope === "chat" ? ON : OFF}`}
		>
			Whole conversation
		</button>
	</div>
);

export default ContextGraphScopeToggle;
